type ResponsiveLabelProps = {
  label?: string | null;
  mobileLabel?: string | null;
};

export function ResponsiveLabel({
  label,
  mobileLabel,
}: ResponsiveLabelProps) {
  const desktopLabel = label ?? mobileLabel;
  const compactLabel = mobileLabel ?? label;

  if (!desktopLabel && !compactLabel) return null;

  if (desktopLabel === compactLabel) {
    return <>{desktopLabel}</>;
  }

  return (
    <>
      <span className="max-xs:hidden">{desktopLabel}</span>
      <span className="xs:hidden">{compactLabel}</span>
    </>
  );
}
